<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md12 class="content-title">
                <h2>Contato</h2>
            </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">     
            <v-flex md12 style="padding:10px;">
                <!-- <v-card >
                    <h3 class="text-blue">PREVISUL SOLUCIONA</h3>
                    <p>                
                    Corretor, se você estiver com dúvidas operacionais
                    (faturamento, emissão, problemas de acesso no Portal do
                    Corretor, entre outros), entre em contato através: 
                    Telefone (11) 2313.7983 e e-mail soluciona@previsul.com.br
                    </p>
                </v-card> -->
                <v-card >
                    <h3 class="text-blue">PREVISUL SOLUCIONA: CENTRAL DE ATENDIMENTO AO CORRETOR</h3>
                    <!-- <p>                
                    Corretor, se você estiver com dúvidas operacionais
                    (faturamento, emissão, problemas de acesso no Portal do
                    Corretor, entre outros), entre em contato através: 
                    Telefone (11) 2313.7983 e e-mail soluciona@previsul.com.br
                    </p> -->
                    <!-- <p>
                        <h3>3003 8533 (capitais e cidades metropolitanas)</h3><br />
                        <h3>e 0800 878 9100 (demais localidades)</h3>
                    </p>
                    <p>De segunda-feira à sexta-feita, das 8h às 18h, Exceto feriados nacionais.</p>
                    <p>
                        <h3>soluciona@previsul.com.br</h3><br />
                        De segunda-feira à sexta-feita, das 8h às 18h. Com prazo de retorno de até 24h,<br />
                        Exceto feriados nacionais.
                    </p> -->
                    <div>
                        <h3>What'sApp: (51) 98268 0607</h3><br />
                        <h3>3003 8533 (capitais e cidades metropolitanas)</h3><br />
                        <h3>e 0800 878 9100 (demais localidades)</h3>
                    </div>
                    <p>De segunda-feira à sexta-feita, das 8h às 18h, Exceto feriados nacionais.</p>
                    <div>
                        <h3>soluciona@previsul.com.br</h3><br />
                        De segunda-feira à sexta-feita, das 8h às 18h. Com prazo de retorno de até 24h,<br />
                        Exceto feriados nacionais.                        
                    </div>
                </v-card>
                
            </v-flex>
            <v-flex md6 style="padding:10px;">
                <!-- <v-card>
                    <h3 class="text-blue">CENTRAL DE SERVIÇOS</h3>
                    <h3>0800 709 8059</h3>
                    <p>De segunda-feira a sexta-feira, das 8h às 21h, exceto feriados nacionais.</p>
                    <p>Canal para gerenciamento de produtos, com serviços como 2ª via de documentos (boleto, certificado), atualização cadastral, entre outros serviços.</p>
                </v-card> -->
                <v-card >
                    <h3 class="text-blue">ATENDIMENTO AO CLIENTE</h3>
                    <div>                
                        <h3>3003 6773 (capitais e cidades metropolitanas)</h3><br />
                        <h3>0800 709 8059 (demais localidades)</h3><br />

                        <ul>
                            <li>
                                Dúvidas, informações, solicitação de documento e cancelamento: 
                                Atendimento também via whatsapp +55 51 98232-0167
                                De segunda-feira a sexta-feira, das 8h às 18h, exceto feriados nacionais.                                 
                            </li>
                            <li>
                                Comunicado e acompanhamento de Sinistro:
                                De segunda-feira a sexta-feira, das 8h às 21h, exceto feriados nacionais.
                            </li>
                            <li>
                                Acionamento de assistências:
                                Serviço 24h, sete dias por semana, inclusive feriados nacionais.
                            </li>
                        </ul>
                    </div>
                </v-card>                
                <br>
                 <!-- <v-card >
                    <h3 class="text-blue">COMUNICADO E INFORMAÇÕES DOS PROCESSOS DE SINISTRO</h3>
                    <h3>0800 709 8059</h3>
                    <p>Atendimento por telefonia fixa.</p>
                    <p>De segunda-feira a sexta-feira, das 8h às 21h, exceto feriados nacionais.</p>
                    <p>Canal para comunicado e informações dos processos de sinistro.</p>
                </v-card>
                <br> -->
                <v-card >
                    <h3 class="text-blue">CAS: CENTRAL DE ATENDIMENTO AO SURDO</h3>
                    <p>Atendimento por TTS - Terminal Telefônico para Surdos ou por SMS, enviando o texto PSSAC para o número:
                        <strong>29734</strong>
                        24h, sete dias por semana, inclusive feriados nacionais.
                    </p>
                </v-card>                
                <br>                
                <v-card >
                    <h3 class="text-blue">SAC: SERVIÇO DE ATENDIMENTO AO CONSUMIDOR</h3>
                    <h3>0800 722 0264</h3>
                    <!-- <p>Atendimento por telefonia móvel e fixa.</p> -->
                    <!-- <p>24h, sete dias por semana, inclusive feriados nacionais.</p>
                    <p>Canal para informações públicas sobre produtos, bem como sugestões, cancelamento ou suspensão de produtos e serviços.</p> -->
                    <p>De segunda-feira a sexta-feira, das 8h às 18h, exceto feriados nacionais.</p>
                </v-card>
                <!-- <br>
                <v-card>
                    <h3 class="text-blue">ACIONAMENTO DE ASSISTÊNCIAS</h3>
                    <p>O serviço de assistências 24 horas deverá ser acionado através dos números:</p>

                     <h3>0800.555.235 (Brasil) +55 11 4133.68.19 (Exterior)</h3>
                    <h3>+55 11 4133.68.19 (Exterior)</h3>
                    <p>Conforme abrangência de cada serviço.</p>
                </v-card> -->
                <!-- <br />
                <v-card>
                    <h3 class="text-blue">SAC: SERVIÇO DE ATENDIMENTO AO CONSUMIDOR</h3>
                    <p>                
                        0800 722 0264
                        24h, sete dias por semana, inclusive feriados nacionais.
                    </p>
                </v-card>                 -->
            </v-flex>



            <v-flex md6 style="padding:10px;">
                <!-- <v-card >
                    <h3 class="text-blue">CAS: CENTRAL DE ATENDIMENTO AO SURDO</h3>
                    <h3>0800 722 0264</h3>
                    <p>Atendimento por TTS - Terminal Telefônico para Surdos ou por SMS, enviando o texto PSSAC para o número:</p>
                    <p>29734 <br>24h, sete dias por semana, inclusive feriados nacionais.</p>
                    <p>Canal para informações sobre produtos, sugestões, reclamações, cancelamento ou suspensão de serviços e produtos.</p>
                </v-card> -->
                 <!-- <v-card >
                    <h3 class="text-blue">CLIENTES RESIDENTES NO EXTERIOR</h3>
                    <h3>+ 55 61 2107-7176</h3>
                    <p>As ligações podem ser realizadas a cobrar.</p>
                    <p>24h, sete dias por semana, inclusive feriados nacionais.</p>
                    <p>Canal para informações gerais para clientes que atualmente residem fora do Brasil.</p>
                </v-card> -->
                <v-card >
                    <h3 class="text-blue">ATENDIMENTO AO CLIENTE NO EXTERIOR</h3>
                    <p>                
                        24h, sete dias por semana, inclusive feriados nacionais.
                        As ligações podem ser realizadas a cobrar.
                        <ul>
                            <li>
                                Serviços e informações: +55 (61) 2107 7176                                
                            </li>
                            <li>
                                Solicitação de assistência: +55 (11) 4133 6819 
                            </li>
                        </ul>
                    </p>
                </v-card>                
                <br>
                <v-card >
                    <h3 class="text-blue">OUVIDORIA</h3>
                    <h3>0800 722 0266</h3>
                    <!-- <p>Atendimento por telefonia móvel e fixo.</p> -->
                    <p>De segunda-feira a sexta-feira, das 8h às 18h, exceto feriados nacionais.</p>
                    <!-- <p>O canal de Ouvidoria existe para cuidar dos interesses dos clientes da Previsul, intermediando o entendimento entre consumidor e empresa na busca de uma solução definitiva para uma insatisfação ou reclamação não resolvida nos demais canais disponíveis de atendimento.</p>
                    <p>Nossa Ouvidoria está aqui para assegurar que você seja ouvido e resolver o problema de forma definitiva, além de identificar oportunidades no aprimoramento dos nossos processos. Não ficou satisfeito com a decisão apresentada pela empresa? Procure a nossa Ouvidoria para, juntos, encontrarmos uma solução.</p> -->
                </v-card>
            </v-flex>          
        </v-layout>
    </v-flex>
</template>

<script>

    import { mapState, mapGetters } from 'vuex';
    export default {
        data() {
            return {
            }
        },        
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){
            this.usuario;
        }
    }
</script>
